import React, { useReducer } from 'react';
import DataMapping from "../../Common/context/data-mapping/data-mapping"
import reducer from "../../Common/context/data-mapping/reducer/reducer";
import CheckCreditScore from '../../Common/Components/CheckCreditScore';
import CreditScoreAccountData from '../../Common/Components/CreditScoreAccountData';
import CreditScoreReport from '../../Common/Components/CreditScoreReport';
import "./App.scss";
import Routes from './routes'
import { HashRouter } from 'react-router-dom';
import Loader from '../../Common/Global/Loader';
import 'antd/dist/antd.css';
import Header from '../../Common/Header/Header';


const App = () => {

  const myData = JSON.parse(sessionStorage.getItem("dataMapping"));
  const [data, dispatchData] = useReducer(reducer, myData ? myData : []);

  return (
    <>
      <HashRouter>
        <DataMapping.Provider value={[data, dispatchData]}>
          <Header />
          {data?.["loaderFlag"] ? <Loader /> : null}
          <Routes />
        </DataMapping.Provider>
      </HashRouter>
    </>
  )
}

export default App